<script setup lang="ts">
import { Toaster as VueSonner } from 'vue-sonner'
</script>

<template>
  <VueSonner
    rich-colors
    close-button
    position="top-right"
  />
</template>
